import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import MainLayout from '../components/layout/MainLayout';
import AppHeader from '../components/layout/AppHeader';
import MyRewardPageHeader from '../components/bazzar/MyRewardPageHeader';
import ProfileDesktopView from '../components/profile/ProfileDesktopView';
import { fetchUserProfile } from '../services/authService';
import { mapProfileViewData } from '../services/profileService';
import { clearAuthSession } from '../storage/authStorage';
import { getUserProfile } from '../storage/userProfileStorage';
import { BAZZAR_PATH } from '../routes/paths';

export default function MyProfilePage() {
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [profile, setProfile] = useState(() => mapProfileViewData(getUserProfile()));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchUserProfile()
      .then((data) => {
        if (!cancelled) setProfile(mapProfileViewData(data));
      })
      .catch(() => {
        if (!cancelled) setProfile(mapProfileViewData(getUserProfile()));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleConfirmLogout = () => {
    clearAuthSession();
    window.location.href = '/';
  };

  return (
    <MainLayout>
      <Box sx={{ px: { md: '50px' } }}>
        <AppHeader endVariant="profile" onLogoutClick={() => setLogoutDialogOpen(true)} />
      </Box>

      <Box sx={{ px: { xs: 1.25, sm: 2, md: 3 }, pb: 6, pt: { xs: 1, md: 2 } }}>
        <MyRewardPageHeader
          variant='default'
          title="My Profile"
          backLabel="Back to Home"
          backTo={BAZZAR_PATH}
        />

        {loading ? (
          <Box sx={{ display: 'grid', placeItems: 'center', minHeight: 240 }}>
            <CircularProgress sx={{ color: '#ff00f2' }} />
          </Box>
        ) : (
          <ProfileDesktopView profile={profile} />
        )}
      </Box>

      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            bgcolor: '#1a0834',
            border: '1px solid #ff66f766',
            color: '#fff',
            minWidth: { xs: '90%', sm: 380 },
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: '#fff' }}>Logout</DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#e6d4ff' }}>Are you sure you want to logout?</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setLogoutDialogOpen(false)} sx={{ color: '#e6d4ff', textTransform: 'none' }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmLogout}
            variant="contained"
            sx={{
              textTransform: 'none',
              background: 'linear-gradient(90deg, #822AFF 0%, #FF00F2 100%)',
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </MainLayout>
  );
}
